import { SearchInlineShimmer } from './SearchShimmer';
import ReportModal from '../../components/ReportModal';
import StickyNotesPopup from '../../components/StickyNotesPopup';
import ViewModal from '../../components/ViewModal';
import NotesReportModal from '../notes/NotesReportModal';
import NotesStickyNotesPopup from '../notes/NotesStickyNotesPopup';
import NotesViewModal from '../notes/NotesViewModal';
import LectureFeedbackModal from '../lecture/LectureFeedbackModal';

export default function SearchFeedback({ categoryId, mode, item, onClose }) {
  if (!item || !mode) return null;
  if (categoryId === 3) return <LectureFeedbackModal mode={{ view: 'activity', notes: 'note', report: 'report' }[mode]} lecture={item} queryParams={{}} loadingPlaceholder={<SearchInlineShimmer label="Loading lecture feedback" />} onClose={onClose} />;
  if (categoryId === 4) return <>
    <NotesReportModal open={mode === 'report'} note={item} onClose={onClose} />
    <NotesStickyNotesPopup open={mode === 'notes'} note={item} onClose={onClose} />
    <NotesViewModal open={mode === 'view'} note={item} onClose={onClose} />
  </>;
  return <>
    <ReportModal open={mode === 'report'} question={item} onClose={onClose} />
    <StickyNotesPopup open={mode === 'notes'} question={item} onClose={onClose} />
    <ViewModal open={mode === 'view'} question={item} onClose={onClose} />
  </>;
}
